'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidRouteObj = exports.getRoutePath = exports.getRouteId = undefined;

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _defaults2 = require('lodash/defaults');

var _defaults3 = _interopRequireDefault(_defaults2);

var _negate2 = require('lodash/fp/negate');

var _negate3 = _interopRequireDefault(_negate2);

var _getOr2 = require('lodash/fp/getOr');

var _getOr3 = _interopRequireDefault(_getOr2);

var _flow2 = require('lodash/fp/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _eq2 = require('lodash/fp/eq');

var _eq3 = _interopRequireDefault(_eq2);

var _defaultTo2 = require('lodash/fp/defaultTo');

var _defaultTo3 = _interopRequireDefault(_defaultTo2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.idString = idString;
exports.stripHash = stripHash;
exports.getPath = getPath;
exports.getInfo = getInfo;
exports.getLocationObject = getLocationObject;

var _capeLodash = require('cape-lodash');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function idString(id) {
  // Maybe generate an id?
  if (!(0, _isString3.default)(id)) {
    console.error(id);
    throw new Error('\'id\' must be a string. Got ' + id + ' instead.');
  }

  return id;
}

var getRouteId = exports.getRouteId = (0, _capeLodash.getDefault)('routeId', 'id');
var getRoutePath = exports.getRoutePath = (0, _flow3.default)((0, _capeLodash.getDefault)('routePath', 'path'), (0, _defaultTo3.default)(null));
var isValidRouteObj = exports.isValidRouteObj = (0, _flow3.default)((0, _getOr3.default)(true, 'route'), (0, _negate3.default)((0, _eq3.default)(false))); // We are removing the actual hash.

function stripHash(hash) {
  if (hash[0] === '#') return hash.slice(1);
  return hash;
}

function getPath(trailingSlash, id, path) {
  if (path && (0, _isString3.default)(path)) return path;
  return trailingSlash ? '/' + id + '/' : '/' + id;
}

function getInfo(state, _ref) {
  var id = _ref.id,
      path = _ref.path,
      rest = _objectWithoutProperties(_ref, ['id', 'path']);

  return _extends({}, rest, {
    id: id,
    path: getPath(state.trailingSlash, id, path)
  });
} // Grab the properties we pass along from a location object.


function getLocationObject(_location) {
  var defaultLocation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var loc = (0, _pick3.default)(_location, 'pathname', 'hash', 'search', 'origin', 'protocol', 'port', 'hostname');
  return (0, _defaults3.default)(loc, defaultLocation);
}